import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { AppMainComponent } from './app.main.component';
import { UserService } from './auth/user.service';

@Component({
    selector: 'app-menu',
    template: `
		<ul class="layout-menu">
			<li app-menuitem *ngFor="let item of model; let i = index;" [item]="item" [index]="i" [root]="true"></li>
		</ul>
    `
})
export class AppMenuComponent implements OnInit {

    model: any[];

    constructor(
        public app: AppMainComponent,
        public translateService: TranslateService,
        public userService: UserService
        ) {}

    ngOnInit() {
        this.model = [
            { label: 'Gest. Propiedades', icon: 'pi pi-fw pi-home', routerLink: ['/admin/properties'], admin: true },
            { label: this.translateService.instant('menu.properties'), icon: 'pi pi-fw pi-home', routerLink: ['/b/properties'], admin: false},
            { label: this.translateService.instant('menu.dashboard'), icon: 'pi pi-fw pi-home', routerLink: ['/b/dashboard'], admin: false},
            { label: 'Transacciones', icon: 'pi pi-fw pi-home', routerLink: ['/admin/property-transactions'], admin: true },
            { label: this.translateService.instant('menu.profile'), icon: 'pi pi-fw pi-user-edit', routerLink: ['/b/profile']},
            { label: this.translateService.instant('menu.contact'), icon: 'pi pi-fw pi-envelope', routerLink: ['/b/contact']},
            { label: this.translateService.instant('menu.logout'), icon: 'pi pi-fw pi-sign-out', type: 'logout'}
        ];
        if (this.userService.user.id !== 1) {
            this.model = this.model.filter((item) => !item.admin);
        }
        if (this.userService.user.id === 1) {
            this.model = this.model.filter((item) => item.admin !== false);
        }
    }
}
